import _map from "lodash/map";
import * as React from 'react';
import Droppable from '../Droppable';
import { jsx as ___EmotionJSX } from "@emotion/react";
const TwoList = _ref => {
  let {
    groupedItems,
    setItemOffset,
    targets
  } = _ref;
  return ___EmotionJSX("div", {
    className: "dc-u-ifx dc-u-w-100pc dc-u-h-100pc dc-u-ph-12 dc-u-bgc-grey-100 dc-u-of-auto",
    style: {
      paddingTop: '6vh'
    }
  }, _map(targets, _ref2 => {
    let {
      id,
      language: languageOfTarget,
      maxOffset,
      title
    } = _ref2;
    return ___EmotionJSX(Droppable, {
      droppableId: id,
      extraClass: "dc-u-fxi-f-1 dc-u-m-auto dc-u-fx-jcc dc-u-h-100pc",
      items: groupedItems[id],
      key: id,
      languageOfTarget: languageOfTarget,
      maxOffset: maxOffset,
      setItemOffset: setItemOffset,
      title: ___EmotionJSX("h5", {
        className: "dc-u-ta-center"
      }, title)
    });
  }));
};
export default TwoList;